import React from 'react';

import { ContactEmail } from 'components/Contact';
import { copyToClipboard } from 'utils/copyToClipboard';
import { ReactComponent as CopyIcon } from 'images/copy-icon.svg';

import styles from './CopyTextToClipboard.module.scss';

const CopyTextToClipboard = ({ text = ContactEmail.Support }) => (
  <span className={styles.container} onClick={() => copyToClipboard(text)}>
    {text} <CopyIcon className={styles.icon} />
  </span>
);

export default CopyTextToClipboard;
